import {
  ExclamationTriangleIcon,
  EyeSlashIcon,
  HandThumbUpIcon,
  HeartIcon,
  ScaleIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';

type Icon = ComponentType<SVGProps<SVGSVGElement>>;

/** One icon per Likert row index (0–4); design placeholder until CMS provides assets. */
const OPTION_ICONS: Icon[] = [
  HeartIcon,
  ScaleIcon,
  HandThumbUpIcon,
  ExclamationTriangleIcon,
  EyeSlashIcon,
];

export function MatchQuizOptionIcon({
  optionIndex,
  className,
}: {
  optionIndex: number;
  className?: string;
}) {
  const Icon = OPTION_ICONS[optionIndex % OPTION_ICONS.length] ?? HeartIcon;
  return <Icon className={className} aria-hidden />;
}
